import GlobalStyles from './styles/GlobalStyles';
import createTheme from './styles/theme';
import { CURRENCIES } from 'common-ui/src/utils/constants';
import { commonInitApp } from 'common-embedded';

const brandObject = {
  country: 'us',
  brandId: 'npr',
  currencyCode: CURRENCIES.USD,
};

const initApp = commonInitApp({ brandObject, createTheme, GlobalStyles });

export default initApp;